module.exports = "images/doc-day-add-drag.b652bdc8cd5f450cb3450a9c77be7e4f.gif";